import { format } from 'date-fns';
import { dateformat } from '@/utils/GlobalConstants';
import { Action } from '@/Components/Actions/Action'
import { AcknowledgedIcon, SeenIcon } from '@/Components/ui/Icons/TooltipIcon';
import { getStatusColor } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface ActionPopupProps {
    action: Action
}

const ActionPopup = ({ action }: ActionPopupProps) => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <div className='flex flex-col w-full text-2xl'>
                <div className='flex flex-row mb-4'><div className="w-48 font-semibold">Work Package:</div><div>{action.workPackage}</div></div>
                <div className='flex flex-col gap-4 mb-4'>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Raised By: </div> {action.raisedBy ? action.raisedBy : "N/A"} - {format(new Date(action.date), dateformat)}</div>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Owner: </div><div>{action.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{action.seen ? <SeenIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}{action.acknowledged ? <AcknowledgedIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}</div></div>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Status: </div><div className={'w-48 text-center ' + getStatusColor(action.status)}>{action.status}</div></div>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Due Date: </div> {format(new Date(action.dueDate), dateformat)}</div>
                </div>
                <div className='mb-4'>
                    <div className='font-semibold'>Action:</div>
                    <div>{action.description}</div>
                </div>
                {action.notes && (
                    <div className='mb-4'>
                        <div className='font-semibold'>Notes:</div>
                        <div>{action.notes}</div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div id="action-popup" className='flex flex-col gap-4'>
            <div className='flex flex-row'><div>Work Package:</div><div className='px-2'>{action.workPackage}</div></div>
            <div className='flex flex-row my-4 justify-between'>
                <div className='flex flex-col gap-4 mr-8'>
                    <div className='flex flex-row'><div className="w-24">Raised By: </div> {action.raisedBy} - {format(new Date(action.date), dateformat)}</div>
                    <div className='flex flex-row'><div className="w-24">Owner: </div><div>{action.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{action.seen ? <SeenIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}{action.acknowledged ? <AcknowledgedIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}</div></div>
                    <div className='flex flex-row'><div className="w-24">Status: </div><div className={'w-24 text-center ' + getStatusColor(action.status)}>{action.status}</div></div>
                    <div className='flex flex-row'><div className="w-24">Due Date: </div> {format(new Date(action.dueDate), dateformat)}
                    </div>
                </div>
            </div>
            <div>
                <div>Action:</div>
                <div>{action.description}</div>
            </div>
            {action.notes && (
                <div>
                    <div>Notes:</div>
                    <div>{action.notes}</div>
                </div>
            )}
        </div>
    )
}

export default ActionPopup